import Common from './Common'
import Control from './Control'
import Create from './Create'
import NatList from './NatList'

export default {
  Common,
  Control,
  Create,
  NatList
}